import { REPORT_TEMPLATE, type IReportCardInfo, type HeadPlayerCardData } from '@/types';
import type { BaseCardService } from './abstract-base-card-service';
import { BaseCardServiceImpl, type BaseReportCardData } from './abstract-base-card-service';
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { ReportApiService } from '@/infrastructure/api-functions/report-api-service';
import _ from 'lodash'
import { I18nService } from '../i18n-service';

export const HeadPlayerService = Symbol('HeadPlayerService');

export type HeadPlayerService = BaseCardService<HeadPlayerCardData>

@injectable()
export class HeadPlayerServiceImpl extends BaseCardServiceImpl<HeadPlayerCardData> implements HeadPlayerService {
    _modelData = {
        isLoading: false,
        isFailed: false,
        isSuccess: false,
        data: undefined,
    };

    templateType = REPORT_TEMPLATE.HEAD_PLAYER_ANALYSIS;

    constructor(
    @inject(ReportApiService) _reportApiService: ReportApiService,
    @inject(I18nService) private readonly _i18nService: I18nService
    ) {
        super(
            _reportApiService
        );
    }

    private _generateHeadPlayerData(cardInfo: BaseReportCardData<IReportCardInfo>): HeadPlayerCardData {
        const headPlayerData = cardInfo.data?.[REPORT_TEMPLATE.HEAD_PLAYER_ANALYSIS]

        return {
            description: headPlayerData?.HEAD_PLAYER_GPT?.comprehensive_overview || this._i18nService.t('report.noData'),
            companyList: headPlayerData?.HEAD_PLAYER_GPT?.key_player_analysis,
        }
    }

    updateFetchData(getUpdateValue: (v: BaseReportCardData<IReportCardInfo>) => BaseReportCardData<IReportCardInfo>): void {
        const updatedValue = getUpdateValue(_.omit(this.modelData, 'data'));

        const dataHaveFromUpdated = _.has(updatedValue, 'data')
        if (dataHaveFromUpdated) {
            this.update(modelData => ({
                ...modelData,
                ...updatedValue,
                data: this._generateHeadPlayerData(updatedValue),
            }));
        } else {
            this.update(m => ({
                ...m,
                ...updatedValue,
                data: m.data,
            }));
        }
    }
}
